<div mat-dialog-title>
    <span *ngIf="!duplicateProduct">Update Confirmation</span>
    <span *ngIf="duplicateProduct">Duplicate Product</span>
    <div class="dialog-close-button">
        <a (click)="onClose()" id="close">
            <img src="/assets/images/close-popup.png">
        </a>
    </div>
</div>
<div mat-dialog-content cdkFocusInitial>
    <span *ngIf="data.productDescription">
        <span *ngIf="!duplicateProduct">{{data.itemCIN}} - {{data.productDescription}} has been {{data.event}} to your
            {{data.favList.name.replace(' ', '&nbsp;')}} list.</span>
        <span *ngIf="duplicateProduct">{{data.duplicateProducts[0]}} - {{data.productDescription}} is already on this
            list.</span>
    </span>
    <span *ngIf="data.event === 'created'">
            {{data.favList.name.replace(' ', '&nbsp;')}} list has been {{data.event}}.
    </span>
</div>
<div mat-dialog-actions>
    <button *ngIf="!duplicateProduct" mat-raised-button id="btn-favourites" (click)="redirectTofavList()">
        <span>Go to
            <span *ngIf="data.event === 'moved'">Selected List</span>
            <span *ngIf="data.event === 'added'">Favorites Lists</span>
            <span *ngIf="data.event === 'created'">New List</span>
        </span>
    </button>
    <button mat-raised-button [mat-dialog-close]="true" id="btn-ok">Close</button>
</div>